import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ScrollView, View } from 'react-native';
import { IProfilesListViewModelType } from './IProfilesListViewModel';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { component } from '../../Decorators/Component';
import { CoreConfig } from '../../../CoreConfig';
import { AnimatedImageView } from '../Image/AnimatedImageView';
import { ParagraphView } from '../Typography/Paragraph';
import { AnimatedPressable } from '../Buttons/AnimatedPressable';
import { useColorScheme } from '../../Hooks/UseColorScheme';
import { useColorSchemeContext } from '../../Contexts/ThemeContext';
export const ProfilesListComponent = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.profilesList,
    dependencies: {
        viewModel: IProfilesListViewModelType
    },
    style(theme, mediaQuery, window, props) {
        return {
            container: {
                minHeight: 130,
            },
            item: Object.assign({ paddingHorizontal: 20, paddingVertical: 20, flexDirection: 'row', alignItems: 'center' }, props.horizontal && {
                paddingVertical: 0,
                flexDirection: 'column'
            }),
            image: Object.assign({ height: 40, width: 40, marginEnd: 30 }, props.horizontal && {
                height: 80,
                width: 80,
                marginBottom: 15,
                marginEnd: 0
            }),
            title: {
                fontSize: 18,
                lineHeight: 20,
                textAlign: 'center',
                fontWeight: '400',
                marginBottom: 60
            },
            itemTitle: Object.assign({ textAlign: 'center', marginBottom: 0 }, !props.horizontal && {
                textAlign: 'left',
                fontWeight: '600',
                flex: 1
            }),
            icon: {
                height: 30
            }
        };
    }
})(({ viewModel, style, assets, localization, horizontal }) => {
    const color_scheme = useColorScheme();
    const color_scheme_context = useColorSchemeContext();
    return (_jsxs(View, { children: [horizontal && (_jsx(ParagraphView, { textStyle: style === null || style === void 0 ? void 0 : style.title, children: (localization === null || localization === void 0 ? void 0 : localization.title) || (localization === null || localization === void 0 ? void 0 : localization.select_your_region) || 'Select Your Region' })), _jsx(ScrollView, { style: style === null || style === void 0 ? void 0 : style.container, contentContainerStyle: horizontal && { minWidth: '100%', justifyContent: 'center', paddingHorizontal: 20 }, horizontal: horizontal, children: viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.profiles.map(profile => {
                    var _a, _b, _c;
                    return (_jsxs(AnimatedPressable, { style: [style === null || style === void 0 ? void 0 : style.item, profile.keyword === viewModel.viewData.profileKeyword && horizontal && { opacity: 0.6 }], onPress: () => viewModel === null || viewModel === void 0 ? void 0 : viewModel.updateProfile(profile), children: [_jsx(AnimatedImageView, { image: profile.image_url, fallbackImage: (_a = assets === null || assets === void 0 ? void 0 : assets.images) === null || _a === void 0 ? void 0 : _a.country_image, containerStyle: style === null || style === void 0 ? void 0 : style.image, resizeMode: "contain" }), _jsx(ParagraphView, { textStyle: style === null || style === void 0 ? void 0 : style.itemTitle, children: profile.title }), !horizontal && profile.keyword === viewModel.viewData.profileKeyword && (_jsx(AnimatedImageView, { image: (_b = assets === null || assets === void 0 ? void 0 : assets.images) === null || _b === void 0 ? void 0 : _b.check_icon_url, icon: ((_c = assets === null || assets === void 0 ? void 0 : assets.images) === null || _c === void 0 ? void 0 : _c.check_icon) || 'si-check', color: (color_scheme.scheme === 'dark' || color_scheme_context.scheme === 'dark')
                                    ? '#fff'
                                    : color_scheme.colors.text, containerStyle: style === null || style === void 0 ? void 0 : style.icon }))] }, profile.keyword));
                }) })] }));
});
